import { Item } from '@app/models/item';
import {
  EnumSubItemsTypes
} from '@app/order/recommendation/new-domain-recommendation/interfaces/new-domain-recommendation.interfaces';

export function CartHasKsuiteParam(cartAttributes): boolean {
  console.log(`CartHasKsuiteParam ${cartAttributes?.['ksuite_order']}`);
  return cartAttributes?.['ksuite_order'];
}
